import { NextPage, GetStaticProps } from 'next';
import Rss from '@/components/screens/rss/Rss';
import { API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

const RssPage: NextPage<IWidgetsSideBar> = ({ todayWidget }) => {
  return <Rss todayWidget={todayWidget} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const [todayWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`)]);
  const [todayWidget] = await Promise.all([todayWidgetRes.json()]);

  return { props: { todayWidget }, revalidate: REVALIDATE_TIME };
};

export default RssPage;
